export default {
  app: {
    sceneChange: '場景改變',
    upgrade2seniorVip2useExclusiveMaterial: '升級為企業高級會員後，可使用企業高級會員專屬素材',
    continueEditing: '繼續編輯',
    upgrade2seniorVip: '升級為企業高級會員',
    upgrade2vip2useExclusiveMaterial: '升級為企業高級會員後，可使用高級會員專屬素材',
    Upgrade2CorMem: '升級為企業會員',
    reduceDurationOrUpgrade2vip2export: '由於當前项目時長已經超過3.5分鐘，若您需要匯出，請減少時長或升級為企業會員',
    upgrade2vip2export: '您正在使用 （高級） VIP功能或資源，若您需要匯出視頻，還請升級會員。'
  },
  nameContent: {
    recName: '錄音名稱',
    inputRecTitle: '輸入錄音名稱，有助於你方便的管理錄音。',
    plzInputRecTitle: '請輸入錄音名稱',
    recTitleRestriction: '請將名稱限制在12字以內'
  },
  generateVoice: {
    AIInputWordsSynthesizeSpeech: 'AI智慧-輸入文字 合成語音',
    soundLib: '音庫',
    speed: '語速',
    slow: '慢',
    fast: '快',
    insertPause: '插入停頓',
    s: '秒',
    frame: '畫面',
    rec: '錄音',
    word: '字',
    audition: '試聽',
    synthesizeSpeech: '合成語音',
    comfirm: '確定',
    synthesizingSpeech: '正在合成語音',
    LinChiling: '林志玲',
    plzInputWordsHere: '請在此處輸入文字',
    cantExceed150Words: '每次轉換不能超過150字',
    inputHere2synthesizeSpeech: '在這裡輸入文字即可快速合成語音。',
    pauseRestriction: '累計添加的停頓不可超過20s',
    systemError: '系統開小差了',
    untitled: '未命名'
  },
  setUploadRecordName: {
    renameRec: '錄音重命名',
    confirm: '確定'
  },
  tip: {
    turnOffTip: '關閉新手提示',
    popupTip: '氣泡提示'
  },
  popup: {
    chooseMaterial2replace: '選擇右邊的素材可進行替換。'
  },
  hand: {
    chooseGesture: '選擇手勢',
    dontUseGesture: '不使用手勢',
    empty: '空空如也',
    previewAfterChosenGesture: '選擇好手勢後，點擊畫布下方的“預覽”可看效果哦！'
  },
  isInternet: {
    networkError: '目前作品已保存。但由於網路連接逾時，暫時無法進行其他操作。網路恢復後可繼續編輯作品。'
  },
  preview: {
    upgrade2export: '您使用了（高級）VIP素材和功能，若您需要匯出還請升級會員',
    videoContainsVipMaterialOrFunction: '視頻中含有VIP素材或功能'
  },
  quickManu: {
    workManagement: '作品管理',
    new: '新建',
    template: '範本',
    story: '故事板',
    vipService: '會員服務',
    tip: '新手提示',
    openTipsPrompt: '開啟新手模式，我們會在創作過程中對難度較高的功能進行較為詳細的提示。若關閉，則我們會在操作中做較為簡要的提示。開啟或關閉均不會影響您的創作。',
    clickHere2closeOrOpenTips: '點擊這裡可以關閉或開啟新手提示',
    whatTipsDo: '新手提示會在每一步操作時進行較為詳細的提示，幫助你快速搞定動畫'
  },
  style: {
    chooseStylePrompt: '選擇一個風格後，場景頁、背景、道具、形狀均會切換至相應的風格'
  },
  chartTextOptions: {
    isShowData: '是否顯示資料',
    data: '數據',
    cateTitle: '類別標題',
    cateTitlePos: '系列標題位置',
    bottom: '下邊',
    right: '右邊',
    submit: '提交'
  },
  effectSetting: {
    effect: '特效',
    gesture: '手勢',
    animPath: '動畫路徑',
    leftOut: '向左移出',
    rightOut: '向右移出',
    upOut: '向上移出',
    downOut: '向下移出',
    leftIn: '從左移入',
    rightIn: '從右移入',
    upIn: '從上移入',
    downIn: '從下移入',
    entrance: '入場',
    noAnim: '無動畫',
    exit: '出場',
    previewAfterSettingInOutAnim: '設置好入場或出場動畫後，點擊畫布下方的“預覽”可看效果哦！',
    write: '書寫',
    appear: '逐行出現',
    draw: '手繪',
    animPathTip: '試試拖動其中一個素材，可調整素材運動的路線；點擊“小剪刀”可取消路徑動畫；調整時間軸上的路徑動畫，可調整運動的時間。',
    popIn: '放大出現',
    popOut: '縮小退出',
    fadeIn: '淡入',
    fadeOut: '淡出',
    in: '入',
    out: '出'
  },
  effectSettingText: {
    effect: '特效',
    gesture: '手勢'
  },
  lottieMotionContent: {
    loading: '載入中',
    empty: '空空如也',
    notFound: '呃哦，未找到',
    successfullyLoaded: '載入成功'
  },
  propSetting: {
    color: '顏色',
    display: '文案',
    layer: '圖層',
    chartType: '圖表樣式',
    motion: '動作',
    stick2top: '置頂',
    stick2bottom: '置底',
    moveUp: '上移',
    moveDown: '下移',
    replace: '替換',
    flip: '翻轉',
    edit: '編輯'
  },
  switchChartType: {
    pie: '圓形圖',
    line: '折線圖',
    bar: '柱狀圖',
    cate: '類別',
    series: '系列',
    editTip: '在表格中可以輸入資料並生成圖表，更新資料後記得點擊“確認”才會生效哦！',
    businessTechnology: '商務科技',
    flat: '扁平簡約',
    cute: '可愛清新',
    blackNwhite: '黑白手繪',
    notFound: '無此風格的圖表！'
  },
  tabs: {
    prop: '屬性',
    anim: '動畫'
  },
  search: {
    searchHistory: '搜索歷史',
    notFound: '沒有找到你搜素內容哦～',
    audition: '試聽',
    use: '使用',
    notFoundInThisStyle: '當前風格內沒有搜索的素材哦～',
    exitSearch: '退出搜索狀態',
    searchTips: '紅色數字代表了我們在每個分類下找到的素材數量，點擊不同分類可進行查看；刪除搜索關鍵字或點擊頂部可退出搜索狀態。',
  },
  soundRecord: {
    notFound: '没有找到内容哦',
    searchMyRec: '搜索我的錄音',
    uploadRec: '上傳錄音',
    AIDub: 'AI智能配音',
    youHave: '您共有',
    times: '次',
    rights: '免費上傳錄音的權益，目前還剩餘',
    loading: '載入中',
    upgrade2seniorVip2useAIsynthesizeSpeech: '升級為高級企業會員後，可進行AI語音合成。即輸入文字、智慧合成語音。',
    upgrade2seniorVip: '升級高級版會員免費用',
    upgrade2seniorVip2UploadMoreRecs: '上傳錄音次數已用完，如需繼續使用，還請升級為高級會員',
    upgrade2vip2uploadRec: '上傳錄音為會員功能，如需使用，還請升級為會員',
    upgrade2vip: '升級會員免費用',
    unTitled: '未命名',
    rec: '錄音'
  },
  charactersSprite: {
    browserDontSupportVideo: '您的流覽器不支持 video 標籤。',
    fail: '失敗'
  },
  modifyUserItem: {
    title: '名稱',
    plzInputTitle: '請輸入名稱',
    tag: '標籤',
    plzInputTag: '請輸入標籤',
    isDelMaterial: '是否刪除素材',
    loading: '載入中',
    cancel: '取消',
    del: '刪除',
    fail: '失敗',
  },
  spritesClick: {
    layerSetting: '圖層設置',
    drag2changeLayer: '可拖動相應的元素，以調節其在畫布中的圖層順序。',
    pic: '圖片',
    text: '文字',
    animMaterial: '動畫素材'
  },
  vipEquity: {
    standardVip: '企業標準版',
    exportHDvideo: '付費範本素材暢享，高清畫質匯出。',
    seniorVip: '企業高級版',
    infiniteWatermarkRemoveDraftRecovery: '無限次視頻去浮水印，项目誤刪找回。',
    ultimateVip: '企業旗艦版',
    infiniteUsageExclusiveService: '所有功能無限使用，專屬服務支援。',
    operateOnTheCorrespondingPaymentPage: '請在相應的付款頁面進行操作',
    encounterProblem: '遇到問題',
    paid: '付款成功',
  },
  vipSprites: {
    paymentFailure: '您的付款還沒有成功哦',
    getHelp: '查看幫助',
    contactCustomerService: '聯繫客服'
  },
  bgSetting: {
    setting: '設置',
    blur: '模糊',
    opacity: '透明度'
  },
  chartSetting: {
    editData: '資料編輯'
  },
  chartTable: {
    editChart: '編輯圖表',
    chartTitle: '圖表標題',
    confirm2update: '點擊確定後，資料才會更新至圖表中',
    confirm: '確定',
    cate: '類別',
    series: '系列'
  },
  chartType: {
    chooseChartType: '選擇圖表樣式'
  },
  colorPicker: {
    pickAcolor: '選擇顏色',
    recentlyUse: '最近使用'
  },
  enterExitEffect: {
    entranceAnim: '入場動畫',
    exitAnim: '出場動畫',
    gesture: '手勢',
    addEntranceGesture: '添加入場的手勢',
    addExitGesture: '添加出場的手勢',
    noAnim: '無動畫',
    draw: '手繪',
    write: '書寫',
    appear: '逐行出現',
    previewAfterSetting: '設置好入場或出場動畫後，點擊畫布下方的“預覽”可看效果哦！',
  },
  fontFamily: {
    chooseFontFamily: '選擇字體',
    downloading: '下載中'
  },
  lottieMotion: {
    lottieMotion: '角色動作',
    generatingMotion: '正在生成動作'
  },
  sceneEffectX: {
    sceneAnim: '轉場動畫',
    basic: '基礎型',
    executive: '華麗型',
    stylized: '特效型',
    camera: '鏡頭型',
    zoomIn: '放大',
    zoomOut: '縮小',
    fadeInFadeOut: '淡入淡出',
    clipboard: '電影打板',
    tvNoise: '電視雪花',
    hands: '手勢下移',
    pullDown: '簾子下移',
    roller: '滾筒刷',
    sqweegee: '玻璃刮',
    poof: '爆出',
    blueColorSmear: '藍色塗抹',
    whiteColorSmear: '白色塗抹',
    fanUp: '扇葉向上',
    fanDown: '扇葉向下',
    spiralzTech: '藍色螺旋',
    spiralz: '灰色螺旋',
    swipe: '橫向劃出',
    sliceVertical: '垂直劃像',
    sliceHorizontal: '水準劃像',
    sliceCenter: '中間劃像',
    slice: '對角劃像',
    cameraUp: '鏡頭上移',
    cameraDown: '鏡頭下移',
    cameraLeft: '鏡頭左移',
    cameraRight: '鏡頭右移',
    slideRight: '從左移入',
    slideLeft: '從右移入',
    slideDown: '從上移入',
    slideUp: '從下移入'
  },
  scenesSetting: {
    copy: '複製',
    collect: '收藏',
    copyLastFrame: '複製最後一幀畫面'
  },
  shortcuts: {
    shortcut: '快速鍵',
    copy: '複製',
    cut: '剪切',
    paste: '粘貼',
    del: '刪除',
    moveUp: '上移',
    moveDown: '下移',
    moveLeft: '左移',
    moveRight: '右移',
    multiSelect: '多選',
    click: '按一下',
    editText: '編輯文字',
    dblclickBlankSpace: '按兩下空白區',
    ifUseMac: '備註：如果您使用的Mac',
    replaceCtrlWithCommand: '請將CTRL切換為Command',
  },
  spriteRightKey: {
    stick2bottom: '置於底層',
    stick2top: '置於頂層',
    layerSetting: '圖層設置'
  },
  textSetting: {
    fontFamily: '字體',
    fontSize: '大小',
    color: '顏色',
    style: '樣式',
    align: '對齊',
    layer: '圖層',
    stick2top: '置頂',
    stick2bottom: '置底',
    moveUp: '上移',
    moveDown: '下移',
    anim: '動畫'
  },
  uploadFile: {
    pic: '圖片',
    bgPic: '背景圖片',
    rec: '錄音',
    bgm: '背景音樂',
    uploadStandard: '上傳標準',
    picRestriction: '圖片：可上傳10M以內的PNG/JPG/JPEG',
    recRestriction: '錄音：可上傳20M以內的MP3，上傳後可添加至單個頁面。該功能為會員專屬。',
    bgmRestriction: '背景音樂：可上傳20M以內的MP3，上傳後可添加至整個視頻。',
    upgrade2seniorVip2uploadMoreRecs: '上傳錄音次數已用完，如需繼續使用，還請升級為高級會員',
    upgrade2seniorVip: '升級高級版會員免費用',
    upgrade2vip2uploadRec: '上傳錄音為會員功能，如需使用，還請升級為會員',
    upgrade2vip: '升級會員免費用'
  },
  volume: {
    volControl: '音量調節',
    allScenes: '全部頁面',
    music: '音樂',
    bgmNotFound: '暫無背景音樂',
    currentScene: '當前頁面',
    audition: '試聽',
    recNotFound: '暫無錄音',
    unTitled: '未命名'
  },
  bg: {
    bgColor: '背景顏色',
    uploadBg: '上傳背景',
    picUploadRestriction: '請上傳PNG/JPG/JPEG格式的圖片，大小不超過10M',
    expandNcollapse: '點擊可展開/收起',
    hereIsUploadedPic: '在這裡可以看到上傳的圖片。'
  },
  personal: {
    picUploadRestriction: '請上傳PNG/JPG/JPEG格式的圖片，大小不超過10M',
    collectCurrentScene: '收藏當前場景',
    uploadVideo: '上傳視頻',
    comingSoon: '即將上線，敬請期待',
    scene: '場景頁',
    deletedWorks: '已刪除作品',
    upgrade2vip2collect: '該場景頁為VIP素材，如需收藏，還請升級為會員。',
    upgrade2vip: '升級為企業會員',
    myScene: '我的場景頁',
    collectSceneSuccessfully: '收藏場景成功',
    hereIsCollectedScenes: '收藏的場景頁都可以在這裡找到。',
    upgrade2seniorVip2UploadMoreRecs: '上傳錄音次數已用完，如需繼續使用，還請升級為高級會員',
    upgrade2seniorVip: '升級高級版會員免費用',
    upgrade2vip2uploadRec: '上傳錄音為會員功能，如需使用，還請升級為會員',
    upgrade2vip: '升級會員免費用'
  },
  scenes: {
    collectCurrentScene: '收藏當前場景'
  },
  shapes: {
    chart: '圖表'
  },
  sound: {
    currentBgm: '當前背景音樂/錄音',
    loop: '迴圈',
    volControl: '音量調節',
    mp3Restriction: '支持MP3格式上傳，大小不超過20M',
    hereIsUploadedBgm: '在這裡可以看到上傳的背景音樂。',
    hereIsUploadedRecs: '在這裡可以看到上傳的錄音。',
    fail2loadAudio: '載入音訊出錯',
    settingBgmHere: '已將該音樂添加至整個視頻中，在這裡可以看到當前添加的背景音樂，並對音量和迴圈操作進行設置。'
  },
  text: {
    addTitle: '添加標題',
    addSubtitle: '添加副標題',
    addBodyText: '添加正文'
  },
  btns: {
    try2addScene: '試試添加場景頁',
    sound: '聲音',
    mine: '我的'
  },
  tip: {
    addingBgVideo: '正在添加視頻背景'
  },
  selection: {
    addEntranceAnim: '點擊可添加入場動畫',
    addExitAnim: '點擊可添加出場動畫',
    changeEntranceTime: '拖動小黑線，可改變素材的入場時間',
    changeExitTime: '拖動小黑線，可改變素材的出場時間',
    timeExceeded: '資料錯誤，元素時間超出總時間'
  },
  bgSettingBtn: {
    networkError: '視頻背景載入失敗，請檢查網路'
  },
  editor: {
    'loading': '正在載入',
    'videoContainsVipMaterial': '視頻中含有VIP素材或功能',
    'loadFailure': '載入失敗'
  },
  editorBtn: {
    undo: '撤銷',
    redo: '返回',
    AIDub: 'AI智能配音',
    AIdraw: 'AI智能繪圖',
    grid: '格線',
    upgrade2vip2export: '您使用了（高級）VIP功能或資源，若您需要匯出視頻還請升級會員',
    operateOnTheCorrespondingPaymentPage: '請在相應的付款頁面進行操作',
    encounterProblem: '遇到問題',
    paid: '付款成功'
  },
  setPathAnim: {
    delAnimPath: '刪除路徑動畫'
  },
  spriteBtn: {
    chooseMaterial2replace: '選擇右邊的素材可進行替換。',
    switchChartType: '切換圖表'
  },
  timeline: {
    previewCurrentScene: '預覽當前頁面',
    timeline: '時間軸',
    checkEveryFrame: '移動小三角，可查看視頻的每個畫面',
    increaseTime: '添加時間',
    editInTheNextScene: '每頁最多可添加時長20秒的視頻。您也可以在下一頁繼續創作',
    reduceTime: '減少時間',
    upgrade2vip2createLongerVideo: '時長在3.5分鐘內的視頻傳播更佳。如需製作時長更長的作品，請升級為企業會員。',
    upgrade2vip: '升級為企業會員',
    timelineBtnUsage: '點擊“+”或“-”可修改每一頁的時間，每頁最長的動畫時間為20秒。'
  },
  memberFooter: {
    upgrade2vip2export: '您使用了（高級）VIP素材或功能，如後續需要匯出還請升級會員。',
    confirm: '確定',
    upgrade2vip2export: '升級會員 免費匯出',
    upgrade2seniorVip2export: '升級高級版會員 免費匯出',
    upgrade2ultimateVip2export: '升級旗艦版會員 免費匯出'
  },
  coverDialog: {
    chooseCover: '選取封面',
    coverExceedRestriction: '截取的封面已經超出10MB限制'
  },
  exportDialog: {
    settingExportInfo: '設置匯出資訊',
    replace: '替換',
    cover: '封面',
    title: '標題',
    tag: '標籤',
    intro: '簡介',
    watermark: '浮水印',
    definition: '清晰度',
    myWork: '我的作品',
    goodTitleCanAttractAudience: '好的標題可吸引更多的觀眾來看',
    plzInputTitle: '請填寫標題',
    inputTags: '填寫標籤便於檢索，最多不超過5個，點擊Enter隔開多個標籤',
    tagsRestriction: '請填寫標籤，每個標籤最多8個漢字或16個字母',
    makeVideoLikePPT: '做視頻像做PPT一樣簡單？快挪步到“來畫視頻”一探究竟吧！',
    introCanTellMoreInfo: '簡介可展示關於視頻的更多背景資訊或內容哦',
    plzInputIntro: '請填寫簡介',
    defaultWatermark: '默認浮水印',
    noWatermark: '無浮水印',
    customWatermark: '自訂浮水印',
    youHave: '您共有',
    removeWatermark: '去浮水印',
    customWatermark: '自訂浮水印',
    times: '次',
    rights: '的權益，目前還剩餘',
    hd: '高清',
    uhd: '超清',
    chosenPicExceedRestriction: '選中圖片已經超出10MB限制',
    upgrade2vip2removeWatermark: '升級為會員後，可去除或自訂浮水印。',
    upgrade2vip2useFreely: '升級會員免費用',
    upgrade2vip2customWatermark: '升級為會員後，可自訂浮水印。',
    upgrade2vip2exportHighDefinitionVideo: '升級為會員後，可進行匯出高畫質（720P/1080P）的視頻',
    upgrade2vip: '升級為會員',
    submitting: '正在提交資料',
    submitSuccessfully: '提交資料成功',
    submitFailed: '提交資料失敗',
    removeWatermark: '去除浮水印',
    customWatermark: '自訂浮水印',
    workCate: '作品分類',
    plzSelectCate: '請選擇分類',
    plzSelectCateForReleasedWork: '請選擇發佈作品的分類',
    isReleaseAsContest: '是否發佈為大賽作品',
    teacher: '指導老師',
    teacherName: '指導老師姓名',
    plzInputTeacher: '請填寫指導老師',
    teachersContactInfo: '指導老師聯繫方式',
    teachersTelOrEmail: '指導老師聯繫方式（電話或者郵箱）',
    plzInputTeachersContactInfo: '請填寫指導老師聯繫方式',
    onlyOneReleaseAllowed: '您只能發佈一次大賽作品',
    confirm2release: '發佈後不能更改作品資訊，確認發佈嗎？',
    released: '您已發佈過大賽作品',
    missDeadline: '您報名的賽區已截止投稿，如需幫助請聯繫官方客服',
    notSignUpPrompt: '您還未報名大賽，請先報名後在進行發佈作品，或者取消勾選大賽',
    signUp: '前往報名'
  },
  savingMask: {
    saving: '正在保存中'
  },
  Draw: {
    recommendUwpApp: '建議下載”來畫視頻”Win10用戶端，體驗更極致的繪畫體驗',
    figureIdentification: '圖形自動識別',
    closeIntelligentRecommendation: '關閉智能推薦',
    saveCurrentWork: '保存當前繪畫作品',
    finishDraw: '完成繪畫',
    redrawPic: '重新繪製圖形',
    redraw: '重畫',
    exitAndDontSave: '退出後將不保留當前繪畫作品',
    exitDraw: '退出繪畫',
    isSaveCurrentDraw: '是否保存當前繪畫？',
    exitDirectly: '直接退出',
    saveNexit: '保存並退出',
    myPainting: '我的繪畫',
    upgrade2seniorVip2getAIdraw: '升級為高級企業會員後，可進行AI智慧繪畫。',
    upgrade2seniorVip2useByFree: '升級高級版會員免費用'
  },
  Guidance: {
    welcome2laihua: '歡迎來到來畫視頻，開啟你的動畫創作之旅。',
    fewTips2learn2createAnim: '幾個小技巧，幫你快速get到動畫創作',
    openNow: '立即開啟',
    skip: '跳過',
    nickname: '王小二',
    laihuaer: '來畫君',
    next: '下一步'
  },
  RightNav: {
    chooseStyle: '選擇風格',
    chooseStylePrompt: '選擇一個風格後，場景頁、背景、道具、形狀均會切換至相應的風格。'
  },
  Scenes: {
    addAnimBetweenScenes: '轉場動畫，在兩個頁面間添加動畫效果',
    addScene: '添加場景頁'
  },
  topnav: {
    quickManu: '快顯功能表',
    preview: '預覽',
    tutorial: '教程',
    export: '匯出',
    save2myDraft: '保存至"我的项目"',
    previewAll: '預覽整個視頻',
    shareOrDownloadAfterExport: '匯出後可分享或下載',
    saved: '已保存',
    saveCoverFailed: '保存封面失敗',
    saveFailed: '保存失敗',
    failed2getDraft: '獲取作品项目失敗',
    dataNotRequest: '未取得作品資料',
    upgrade2vip2exportLongerVideo: '升級為會員後，匯出視頻時長可超過3.5分鐘',
    upgrade2vip: '升級為會員',
    clickRightPart2addMaterial: '您還沒有添加任何素材哦，請點擊右側部分添加',
    logoutPrompt: '退出登錄提示',
    autoLogoutPrompt: '您的帳號所登錄的設備已超出數量限制，當前帳號已自動退出登錄。',
    draftSaved: '我們已保存您的當前项目，重新登錄後可在“作品管理-我的项目”中查看。',
    securityWarning: '若存在帳號和密碼洩露的風險，還請至“個人中心-帳號設置”中修改密碼。'
  },
  Upload: {
    plzUploadPicFile: '請上傳圖片檔',
    finished: '已完成：',
    plzUploadMp3File: '請上傳mp3文件',
    plzChooseSmallerFile: '請選擇小於20MB的檔',
    bgNPropRestriction: '背景，道具素材上傳需限制在10MB內。',
    watermarkRestriction: '浮水印素材上傳需限制在200KB內。',
    uploadFailedPlzcheckNetworkOrFileFormat: '上傳錯誤！請檢查網路或檔案格式',
    uploading: '正在上傳文件',
    uploadFailedPlzTryAgain: '檔上傳錯誤，請重試！'
  }
}


// WEBPACK FOOTER //
// ./src/lang/zh-tw.js